import { useState } from 'react'
import { submitScreeningFeedback } from '../services/screeningFeedbackService'

export const useSubmitScreeningFeedback = (closeDialog) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (feedbackObject) => {
    console.log('submit feedback', feedbackObject)
    
    setIsSubmitting(true)
    
    try {
      const result = await submitScreeningFeedback(feedbackObject)
      
      if (result.success) {
        closeDialog()
      }
      // Error handling is already done in the service
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    isSubmitting,
    handleSubmit,
  }
} 